import React from "react";
import Login from "../pages/Login/index";

const publicRoutes = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "login",
    element: <Login />,
  },
];

export default publicRoutes;
